import React from 'react';
import { formatSize } from 'pano-utils';
import { LibType, PanoTaskType } from '@types';
import TextLink from '@components/TextLink';
import LibModalNavTip from '../layouts/LibModalNavTip';
import {
  LIB_SIZE_LIMIT,
  MATRIX_IMAGE_LIMIT,
  TASK_SIZE_LIMIT,
} from '../constants';

export function TipPano() {
  const sizeSingle = formatSize(TASK_SIZE_LIMIT[PanoTaskType.single]);
  const sizeGroup = formatSize(TASK_SIZE_LIMIT[PanoTaskType.group]);
  return (
    <LibModalNavTip>
      <p>支持2:1与六面体全景图</p>
      <p>{`2:1最大支持${sizeSingle}以内`}</p>
      <p>{`六面体每张最大支持${sizeGroup}以内`}</p>
      <TextLink
        className="mt-10 block text-base"
        href="https://bbs2.720yun.com/article?id=283"
        target="_blank"
        rel="noreferrer"
      >
        2:1与六面体的区别与命名规则
      </TextLink>
    </LibModalNavTip>
  );
}

export function TipPVideo() {
  const sizePanoVideo = formatSize(LIB_SIZE_LIMIT[LibType.panoVideo]);
  return (
    <LibModalNavTip>
      <p>支持最小分辨率 1280x640</p>
      <p>编码格式 H.264</p>
      <p>宽高比例为 2:1</p>
      <p>{`不超过 ${sizePanoVideo} 的.mp4 文件`}</p>
    </LibModalNavTip>
  );
}

export function TipMatrix() {
  const sizeMatrix = formatSize(TASK_SIZE_LIMIT.matrix);
  return (
    <LibModalNavTip>
      <p>{`支持长或宽 ${MATRIX_IMAGE_LIMIT} 像素以上，大小 ${sizeMatrix} 内的 .jpg 图片`}</p>
    </LibModalNavTip>
  );
}
